module.exports = __webpack_public_path__ + "static/media/app-store-badge-coming-soon.843a8796.png";